/* eslint jsx-a11y/no-static-element-interactions: 0 */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/anchor-is-valid: 0 */
/* eslint camelcase: 0 */
/* eslint react/prop-types: 0 */
import { useMemo, useState } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Accordion, AccordionSummary } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { Trans, t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { useFilterControl } from '../../page-framework/filter/FilterControl';

const bttBoilerplateMsg = t`This test has failed due to a test script error, changes to your service (web site changes or service outages are common reasons) or a network outage.`;
const wifiConnectBoilerplateMsg = t`The Wi-Fi Connection Test has failed. Details are shown below.`;
const delayedBoilerplateMsg = t`The test was not run at the scheduled time due to this nPoint being overscheduled with tests.`;
const delayedDetailResult = t`To alleviate or eliminate this issue, increase the interval of this service test or another test with the same or lesser interval on this nPoint.`;
const delayedShortResult = t`Test not run: tests are overscheduled for the nPoint.`;

const useStyles = makeStyles(() => ({
    boilerplate: {
        fontWeight: 500,
        fontSize: 16,
        padding: '10px 5px 15px 0',
    },
    resultText: {
        width: '100%',
        whiteSpace: 'pre-wrap',
        overflowX: 'auto',
        wordWrap: 'break-word',
    },
}));

function GeneralResult({ shortMessage, detailMessage }) {
    const classes = useStyles();
    return (
        <>
            <div className={classes.boilerplate}>{i18n._(shortMessage)}</div>
            <pre className={classes.resultText}>{i18n._(detailMessage)}</pre>
        </>
    );
}

function BttWifiConnectResult({ isBtt, isDelayed, shortMessage, detailMessage }) {
    const classes = useStyles();
    const boilerplateMessage = useMemo(() => {
        if (isDelayed) return delayedBoilerplateMsg;
        return isBtt ? bttBoilerplateMsg : wifiConnectBoilerplateMsg;
    }, [isBtt, isDelayed]);

    return (
        <>
            <div className={classes.boilerplate}>{i18n._(boilerplateMessage)}</div>
            <Accordion elevation={0}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>{i18n._(shortMessage)}</AccordionSummary>
                <pre className={classes.resultText}>{i18n._(detailMessage)}</pre>
            </Accordion>
        </>
    );
}

function ResultColumn({ row }) {
    const { isBttTest, isWifiConnectTest, message, message_detail, message_short } = row;
    const [dialogOpen, setDialogOpen] = useState(false);
    const isDelayed = message_short === 'Scheduling Delay';
    const detailMessage = isDelayed ? delayedDetailResult : message_detail;
    const shortMessage = isDelayed ? delayedShortResult : `Error: ${message_short}`;
    const hasErrors = !_.isEmpty(message_detail) && !_.isEmpty(message_short);
    const filterControl = useFilterControl();

    function handleDialogOpen(event) {
        event.preventDefault();
        event.stopPropagation();
        filterControl.pauseAutoRefresh();
        setDialogOpen(true);
    }

    function handleDialogClose() {
        setDialogOpen(false);
        filterControl.resumeAutoRefresh();
    }

    if (!hasErrors) {
        return message || '';
    }

    return (
        <>
            <a href="#" onClick={handleDialogOpen}>
                {message}
            </a>
            <Dialog open={dialogOpen} maxWidth="md">
                <DialogTitle>
                    <Trans>Result Detail</Trans>
                </DialogTitle>
                <DialogContent>
                    {isBttTest || isWifiConnectTest ? (
                        <BttWifiConnectResult
                            isBtt={isBttTest}
                            isDelayed={isDelayed}
                            shortMessage={shortMessage}
                            detailMessage={detailMessage}
                        />
                    ) : (
                        <GeneralResult shortMessage={shortMessage} detailMessage={detailMessage} />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <Trans>Close</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default function resultColumnRenderer(row) {
    if (!row) return null;
    return <ResultColumn row={row} />;
}
